import { useSetState } from './store/state-setters.js';
import { useHistogramInteractions } from './useHistogramInteractions.js';
import { useHistogramXScale } from './useHistogramXScale.js';
import { useInfiniteZoomConfig } from './useInfiniteZoomConfig.js';
import { useSetClosestBins } from './useSetClosestBins.js';
import { reduceResetInteractions } from '../../core/components/interactions-state-helpers/reducers/reset-reducers.js';
import type { RelativeAbsolutePosition } from '../../core/types/pointer-events.js';

/**
 * Returns a method to reset chart interactions, providing the possibility of
 * setting last mouse position in order to keep showing the crosshair and tooltip.
 */
export const useResetInteractions = () => {
  const setState = useSetState();
  const setClosestBins = useSetClosestBins();
  const { onZoomChange } = useHistogramInteractions();
  const { initialXScale } = useHistogramXScale();
  const infiniteZoomEnabled = useInfiniteZoomConfig();

  const domain = initialXScale.domain();

  return (lastMousePosition?: RelativeAbsolutePosition) => {
    setState(reduceResetInteractions(infiniteZoomEnabled, lastMousePosition));

    if (lastMousePosition) {
      setClosestBins(lastMousePosition);
    }

    onZoomChange?.(domain[0], domain[1], 'reset');
  };
};
